
import {
  ANNOUNCEMENT_STATUS,
  ANNOUNCEMENT_TYPE,
} from "../../../services/flitEnum";

const DISMISSED_ANNOUNCEMENTS_KEY = "flit_dismissed_announcement_ids";

export function getDismissedAnnouncementIds() {
  try {
    const stored = JSON.parse(
      localStorage.getItem(DISMISSED_ANNOUNCEMENTS_KEY)
    );
    return Array.isArray(stored) ? stored : [];
  } catch (error) {
    return [];
  }
}

export function dismissAnnouncement(announcementId) {
  const ids = getDismissedAnnouncementIds();
  if (!ids.includes(announcementId)) {
    ids.push(announcementId);
    localStorage.setItem(DISMISSED_ANNOUNCEMENTS_KEY, JSON.stringify(ids));
  }
}

export function undismissAnnouncement(announcementId) {
  const ids = getDismissedAnnouncementIds().filter(
    id => id !== announcementId
  );
  localStorage.setItem(DISMISSED_ANNOUNCEMENTS_KEY, JSON.stringify(ids));
}

export function getAnnouncementStatusCssClasses(status) {
  var type;
  switch (status) {
    case ANNOUNCEMENT_STATUS.DRAFT:
      type = "info"
      break;
    case ANNOUNCEMENT_STATUS.PUBLISHED:
      type = "success"
      break;
    case ANNOUNCEMENT_STATUS.DELETED:
      type = "dark"
      break;
    default: 
      type = ""
  }

  return `label label-lg label-light-${type
    } label-inline`;
}

export function getAnnouncementTypeCssClasses(announcementType) {
  var type;
  switch (announcementType) {
    case ANNOUNCEMENT_TYPE.GENERAL:
      case ANNOUNCEMENT_TYPE.UPDATE:
      type = "primary";
      break;
    case ANNOUNCEMENT_TYPE.FEATURE:
      case ANNOUNCEMENT_TYPE.EVENT:
        case ANNOUNCEMENT_TYPE.FEEDBACK:
      type = "info";
      break;
    case ANNOUNCEMENT_TYPE.BUG_FIX:
      case ANNOUNCEMENT_TYPE.POLICY:
        case ANNOUNCEMENT_TYPE.SUPPORT:
      type = "success";
      break;
    case ANNOUNCEMENT_TYPE.MAINTENANCE:
      case ANNOUNCEMENT_TYPE.PERFORMANCE:
        case ANNOUNCEMENT_TYPE.SECURITY:
      type = "warning";
      break;
    default:
      type = ""
  }

  return `label label-lg label-light-${type
    } label-inline`;
}

